<template>
    <page-content>
        <div slot="header">
            <h4 class="page-title-padding">公司报表</h4>
            <div class="picker">
                <el-date-picker
                    ref="picker"
                    v-model="monthVal"
                    type="month"
                    placeholder="选择"
                    size="mini"
                    :editable='false'
                    :clearable="false"
                    :picker-options="pickerOptions"
                    @change="monthChange"
                    > 
                </el-date-picker>
                <div @click="pickerChange" class="picker-format">{{`${assessDate[0]}/${assessDate[1]}`}}</div>
            </div>
            <el-button style="margin-left:20px;" icon="el-icon-download" size="mini" type="primary" :loading="dowLoading" @click="downloadData">导出数据</el-button>
            <el-input placeholder="分" size="mini" v-model="score" style="width:200px;margin-left:20px;">
                <template slot="prepend">低于</template>
                <template slot="append">
                    <el-button size="mini" type="primary" @click="searchClick">搜索</el-button>
                </template>
            </el-input>
        </div>
        <div slot="content">
            <div>
                <el-table v-loading="companyLoading" @filter-change="filterChange"  :data="companyData" max-height="780" show-summary :summary-method="getSummariesCompany" size="mini">
                    <el-table-column sortable prop="department" column-key="department" :filters="filterData.department || []" label="部门" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column sortable prop="position_name" column-key="position_name" :filters="filterData.position_name || []" label="岗位" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column sortable prop="examinee_name"  label="被考评人" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column sortable prop="score" label="分数" header-align="center" align="center">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import {computeAssessDate} from '@/assets/js/date'
import {downloadExcel} from '@/assets/js/exportdata'
import {multiFilter} from '@/assets/js/filtrate'
export default {
    data(){
        return {
            assessDate:'',
            companyLoading:false,
            dowLoading:false,
            score:'',                                   //搜索分数
            companyData:[],                             //公司数据
            filterData:[],                              //筛选数据
            initData:[],                                //初始数据
            tableFilter:[],                             //筛选条件数据
            monthVal:'',                                //月份
            pickerOptions:{
                disabledDate(time){
                    return time.getTime() > Date.now();
                }
            }
        }
    },
    created(){
        this.assessDate=computeAssessDate()[0].split('/');
        this.monthVal=this.assessDate[1];
        this.getCompanyData();
    },
    methods:{
        getCompanyData(score=''){                              //公司数据
            const param={
                start:this.assessDate[0],
                end:this.assessDate[1],
                score,
            }
            this.companyLoading=true;
            this.$http.get('export/getAllDepartmentExportData',{params:param}).then(v=>{
                if(v.status === 200 && v.data.status){
                    this.initData=JSON.parse(JSON.stringify(v.data.data));
                    this.companyData=v.data.data;
                    this.setAllFilterData(JSON.parse(JSON.stringify(v.data.data)));
                }else{
                    this.companyData=[];
                    this.initData=[];
                }
                this.companyLoading=false;
            }).catch(v=>{this.companyLoading=false;})
        },
        searchClick(){                                          //搜索
            this.getCompanyData(this.score)
        },
        downloadData(){                                          //导出excel
            const param={
                start:this.assessDate[0],
                end:this.assessDate[1],
                score:this.score,
            }
            this.dowLoading=true;                               
            downloadExcel('get','/export/allDepartment',{params:param},`${this.assessDate[0]}/${this.assessDate[1]}期公司报表`,v=>{
                this.dowLoading=false; 
            })
        },
        filterChange(data){                                         //筛选
            const initData = JSON.parse(JSON.stringify(this.initData));
            const val=Object.keys(data);
            if(this.tableFilter.length===0){        //保存全部筛选数据
                this.tableFilter.push(data)
            }else{
                let isKey=true;
                this.tableFilter.forEach((v,index)=>{
                    const $key=Object.keys(v)
                    if(val[0] === $key[0]) isKey=index;
                })
                isKey===true ? (this.tableFilter.push(data)) : (this.tableFilter.splice(isKey,1,data))
            }
            this.companyData=multiFilter(initData,this.tableFilter);
        },
        setAllFilterData(data){                                 //获得筛选数据
            let filterData={ //初始所需数据
                group_name:[],
                position_name:[],
                department:[],
                leader_name:[],
            };
            for(let i in filterData){
                data.forEach(v=>{
                    if(!filterData[i].some(item=>item.text===v[i])){
                        filterData[i].push({
                            text:v[i],
                            value:v[i],
                        });
                    }
                })
            }
            this.filterData=filterData;
        },
        getSummariesCompany(){
            return [`共${this.companyData.length}条数据`]
        },
        monthChange(v){         //月份选择
            this.assessDate=computeAssessDate(v)[1].split('/');
            this.getCompanyData(this.score);
        },
        pickerChange(){
            this.$refs.picker.$el.firstElementChild.focus();
        }
    },
    components:{
        pageContent
    },
}
</script>
<style>
.el-date-picker .el-month-table .today .cell{
    color: #606266;
    font-weight: 500;
}
</style>
<style scoped>
    .picker{
        width: 220px;
        display: inline-block;
        position: relative;
    }
    .picker-format{
        position: absolute;
        background: #ffffff;
        font-size: 12px;
        top: 6px;
        left: 30px;

    }
</style>

